<script setup lang="ts">
import { useScreen } from "@/composable/useResponsive";
import DRBtnIcon from "./DRBtnIcon.vue";
import DRBtn from "./DRBtn.vue";

withDefaults(
  defineProps<{
    icon?: string;
    rightIcon?: string;
    label?: string;
    disabled?: boolean;
    size?: number;
    btnSize?: "xs" | "sm" | "lg";
    variant?:
      | "primary"
      | "secondary"
      | "outline"
      | "outline-danger"
      | "flat"
      | "flat-danger";
  }>(),
  {
    variant: "primary",
  }
);

const { screen } = useScreen();
</script>

<template>
  <DRBtn
    v-if="screen.gt.sm"
    v-bind="$attrs"
    :disabled="disabled"
    :label="label"
    :icon="icon"
    :variant="variant"
    :size="btnSize"
  ></DRBtn>
  <DRBtnIcon
    v-else
    v-bind="$attrs"
    :disabled="disabled"
    :icon="icon"
    :size="size"
    :variant="variant"
  ></DRBtnIcon>
</template>
